// src/pages/PricingPage.js
import React from 'react';
import Pricing from '../components/Pricing';

function PricingPage() {
  return (
    <div className="pt-24">
      <Pricing />
    </div>
  );
}

export default PricingPage;